import { cva, type VariantProps } from 'class-variance-authority';
import styles from './position.module.css';
import type { InputType } from 'storybook/internal/types';

export const positionVariants = cva('', {
  variants: {
    position: {
      absolute: styles['position-absolute'],
      static: styles['position-static'],
      relative: styles['position-relative'],
      fixed: styles['position-fixed'],
      sticky: styles['position-sticky'],
      inherit: styles['position-inherit'],
      initial: styles['position-initial'],
      revert: styles['position-revert'],
      revertLayer: styles['position-revert-layer'],
      unset: styles['position-unset'],
    },
  },
  defaultVariants: {
    position: 'static',
  },
});

export type PositionVariants = VariantProps<typeof positionVariants>;

export const positionOptions: PositionVariants['position'][] = [
  'absolute',
  'static',
  'relative',
  'fixed',
  'sticky',
  'inherit',
  'initial',
  'revert',
  'revertLayer',
  'unset',
];

export const positionArgTypes: Record<string, InputType> = {
  position: {
    control: 'select',
    options: positionOptions,
    description:
      'CSS position property for element positioning. Use with top, right, bottom, left props.',
    table: {
      type: { summary: 'PositionValue' },
      category: 'Position',
    },
  },
};
